import { useHistory } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../uikit/Button/Button';
import SvgAdd from '../../../icons/SvgAdd';
import Flex from '../../../uikit/Flex/Flex';
import Text from '../../../uikit/Text/Text';
import Modal from '../../../uikit/Modal/Modal';
import SvgLink from '../../../icons/SvgLInk';
import Loader from '../../../uikit/Loader/Loader';
import Toast from '../../../uikit/Toast/Toast';
import { AppDispatch, RootState } from '../../../store';
import DashBoard from './DashBoard';
import CreateNewEvent from './CreateNewEvent';
import styles from './eventscheduler.module.css';
import { getScheduleMiddleWare } from './store/middleware/eventmiddleware';


const EventScheduler = () => {
  const dispatch: AppDispatch = useDispatch();
  const [isopen, setIsOpen] = useState(false);
  const history = useHistory();
  const [editlist, setEditList] = useState();
  const [isLoader, setisLoader] = useState(false);
  const [schedule, setschedule] = useState([]);
  const [editmembers, seteditmembers] = useState([]);
  const [reset, setreset] = useState(false);
  const [focus,setfocus] = useState(0)
  const [isView,setisView] = useState(false)
  const searchParams = new URLSearchParams(location.search);
  const eventid = searchParams.get('event');
  const cardRefs = useRef([]);

  
  const {
    data,
    interviewer,
    shareLink,
    addmembers,
    datetime,
    isLoading,
    success,
    google,
    outlook,
    user_id,
    is_plan
  } = useSelector(({ permissionReducers,schedulerReducers,userProfileReducers}: RootState) => ({
    is_plan: permissionReducers.is_plan,
    isLoading: schedulerReducers.isLoading,
    data: schedulerReducers.data,
    user_id : userProfileReducers.user.id,
    interviewer: schedulerReducers.interviewer,
    shareLink: schedulerReducers.shareLink,
    addmembers: schedulerReducers.addmembers,
    datetime: schedulerReducers.datetime,
    success: schedulerReducers.suceess,
    google: schedulerReducers.google,
    outlook: schedulerReducers.outlook,
  }));


    // plan based page redirection condition
    useEffect(() => {
      if (!is_plan) {
        sessionStorage.setItem('MyAccountDropdown','1')
        history.push('/account_setting/subscription');
      }
    });

  useEffect(() => {
    dispatch(getScheduleMiddleWare(undefined))
    if(Number(eventid) !== 0){
      setfocus(Number(eventid))
    }
  }, []);

  function editdata(id: number, datalist: any) {
    if (id !== undefined && id !== null) {
      setIsOpen(true);
      setreset(false)
      setEditList(datalist);
    }
  }

  function HandleButton(ToastMessage){
      if (ToastMessage) { Toast('Event updated successfully.');}
      else{Toast('Event created successfully.');}
  }

  useEffect(() => {
    // Check if the ref for the focused card exists and then set focus
    if (cardRefs.current[focus]) {
      cardRefs.current[focus].focus();
    }
  }, [focus]);

  const CreateEvent = () => {
    setIsOpen(true);
    setreset(true)
    setEditList(null);
  };

  function handleView(event_list){
    setisView(true)
    setIsOpen(true);
    setEditList(event_list);
  }


  if (isLoading) {
    return <Loader />;
  }


  return (
    <Flex
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',      
        padding: "10px",
      }}
     
    >
      <Flex row between className={styles.initial} style={{width: "100%", marginLeft:"6px"}}>
        <Flex>
          <Text size={13}>
            Share your availability with candidates and schedule events
          </Text>
        </Flex>

          <Button
            types="primary"
            className={styles.newlink}
            onClick={CreateEvent}
          >
            <Flex row center style={{ cursor: 'pointer' }}>
              <SvgAdd height={10} width={10} fill="#FFFFFF" />
              <Text color="white" size={13}  bold style={{ marginLeft: '10px' }}>
                Create Event
              </Text>
            </Flex>
          </Button>
          {isopen ? (
            <Modal open={isopen}>
              <CreateNewEvent
                setIsOpen={setIsOpen}
                editModel={editlist}
                datetime={datetime}
                teammembers={addmembers}
                google={google}
                outlook={outlook}  
                reset = {reset}
                HandleButton ={HandleButton}  
                isView ={isView}
                setisView={setisView}
              />
            </Modal>
          ) : (
            ''
          )}
        </Flex>

        <Flex className={styles.outline}  height={window.innerHeight-185} style={{overflow:'scroll'}}>
          {data?.length > 0 ? (
            <Flex row wrap marginTop={'10px'}>
              {data &&
                data?.map((list, index) => {
                  return (
                    <Flex key={index}>
                      <DashBoard  
                        ref= {(el) => (cardRefs.current[list.id] = el)} // Assign ref to each card                   
                        list={list}
                        focus = {focus}
                        editdata={editdata}                       
                        response={shareLink}                      
                        interview={interviewer}   
                        actions = {list.emp_id_id === user_id}
                        handleView={handleView}                     
                      />
                    </Flex>
                  );
                })}
            </Flex>
          ) : (
            <Flex className={styles.noevent} marginTop={200} width={'100%'}>
              <Flex middle>
              <SvgLink width={16} height={16} fill={'#888888'} />
              </Flex>
              <Text size={13} align={'center'} color='placeholder'> No scheduler links created yet.</Text>
              <Text size={13} align={'center'} color='placeholder'>
                Scheduler links allow candidates to pick a date and time that
                works for them.
              </Text>
            </Flex>
          )}
        </Flex>
      </Flex>
  );
};

export default EventScheduler;
